import React from 'react';
import type { MemorySidebarUIProps } from 'redux/selectors/timeline.memories';
import { MemoryEmptyState } from './MemoryEmptyStates';
import styles from './MemoryGroupEmptyState.module.scss';

interface Props {
  ui: MemorySidebarUIProps;
}

export function MemoryGroupEmptyState(props: Props) {
  const { ui } = props;

  return (
    <div className={styles.container}>
      <MemoryEmptyState emptyState={ui.emptyStateType} isToday={ui.isToday} />
    </div>
  );
}
